import { Component, OnInit } from '@angular/core';
import { DownloadFileService } from '@root/shared/services/download-file.service';
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { DomSanitizer } from "@angular/platform-browser";
import saveAs from 'file-saver';

@Component({
  selector: 'app-advertisement',
  templateUrl: './advertisement.component.html',
  styleUrls: ['./advertisement.component.scss']
})
export class AdvertisementComponent implements OnInit {
  advertisementList!: any[];

  constructor(private apiService: ApiService, public downloadFileService: DownloadFileService, public sanitizer: DomSanitizer,) { }

  ngOnInit() {
    this.readAdvertisement();
  }

  public readAdvertisement() {
    const obj = {
      type: "Advertisement",
      year: "",
      month: ""
    };
    this.apiService.postData(Urls.readArticles, obj).subscribe(
      response => {
        response.data.articles.forEach((article: any) => {
          if (article.video) {
            const link = "https://www.youtube.com/embed/";
            if (article.video.startsWith('https://www.youtube.com/watch?')) {
              const embed = article.video.split("watch?v=")[1];
              article.video = link + embed;
            } else if (article.video.startsWith("https://youtu.be/")) {
              const embed = article.video.split("https://youtu.be/")[1];
              article.video = link + embed;
            }
          }
        });
        this.advertisementList = response.data.articles || [];
      },
      error => { }
    )
  }

  public downloadFile(path: string, name: string) {
    this.downloadFileService.export(path).subscribe(
      data => saveAs(data, name + `.pdf`)
    );
  };

  public getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
